import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface BreadcrumbItem {
  label: string // 显示文本
  path: string // 跳转路由
  query?: Record<string, any> // 自定义参数（优先级最高）
  disabled?: boolean // 是否禁用点击
}

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  // 当前页面的面包屑列表
  const breadcrumbList = ref<BreadcrumbItem[]>([])
  // 全局缓存：每个路径最后一次的query参数（核心：记录各层级原始参数）
  const pathQueryCache = ref<Record<string, Record<string, any>>>({})

  // 设置面包屑列表
  const setBreadcrumbList = (list: BreadcrumbItem[]) => {
    breadcrumbList.value = list
  }

  // 缓存指定路径的query参数（页面跳转时调用）
  const cachePathQuery = (path: string, query: Record<string, any>) => {
    if (!path) return
    pathQueryCache.value[path] = { ...(query || {}) }
  }

  // 获取指定路径的缓存参数
  const getCachedPathQuery = (path: string) => {
    return pathQueryCache.value[path] || {}
  }

  // 清空面包屑（可选：清空缓存）
  const clearBreadcrumbList = (clearCache = false) => {
    breadcrumbList.value = []
    if (clearCache) {
      pathQueryCache.value = {} // 退出页面时清空缓存
    }
  }

  return {
    breadcrumbList,
    pathQueryCache, // 暴露缓存（可选，方便调试）
    setBreadcrumbList,
    cachePathQuery,
    getCachedPathQuery,
    clearBreadcrumbList
  }
})
